'use client';
import { doUseOrderStorageStore } from "@/stores/order-storage-store";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";


export default function TrackingFinishedBooking() {
    const trackingStore = doUseOrderStorageStore(useShallow((state) => state.tracking));
    const resetTracking = doUseOrderStorageStore(useShallow((state) => state.resetTracking));

    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "booking_step",
            step: "booking_finished",
            site_code: trackingStore.siteCode,
            site_id: trackingStore.siteId,
            site_name: trackingStore.siteName,
            size: trackingStore.size,
            booking_id: trackingStore.bookingId,
            currency: trackingStore.currency,
            storage_value: trackingStore.storageValue,
            first_month_value: trackingStore.firstMonthValue,
            ordinary_month_value: trackingStore.ordinaryMonthValue,
            client_type: trackingStore.clientType,
            insurance: trackingStore.insurance,
            payment_method: trackingStore.paymentMethod,
            hashed_email: trackingStore.hashedEmail,
            use_signing: trackingStore.useSigning,
            signing_completed: trackingStore.useSigning && trackingStore.signingCompleted,
        });

        resetTracking();
    }, []);
    return (
        <></>
    );
}
